export default __webpack_public_path__ + "static/media/pic4.7dc7fb57.jpg";